import { render } from "./TemplateTwelve.vue?vue&type=template&id=e1aca01e"
import script from "./TemplateTwelve.vue?vue&type=script&lang=js"
export * from "./TemplateTwelve.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__